export const convertCreoleToHTML = (creoleText: string): string => {
  return creoleText
    .replace(/^\s*\\{2}/, "")
    .replaceAll("----", "<hr/>")
    .replace(/\*\*\s*(\S(?:.*?\S)?)\s*\*\*/g, "<strong>$1</strong>")
    .replace(/(?:(?:\s|^)\* +.+?\\\\)+/g, (match) => {
      const items = match.replace(/(?:^|\s)\* +(.+?)\\\\/g, "<li>$1</li>");
      return `<ul>${items}</ul>`;
    })
    .replaceAll("\\", "<br/>")
    .replaceAll("<br/><br/>", "<br/>");
};
